import axios from 'axios'
import { BASE_URL } from '../ApiService/ApiConfig';

export class TraccarService {

    async consultarEstadoCandado(candado) {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }

        }

        return await axios.get(`${BASE_URL}/traccar/uniqueid/` + candado, config)
            .then(res => res.data);
    }



}
